import template from "./tax-forms.html";

ko.components.register('tax-forms', {
    template: template
});